(() => {
  if (window.__pfxCro) return;
  window.__pfxCro = true;

  const biggest = img => {
    const set = (img.getAttribute('srcset') || '').split(',').map(s => s.trim().split(/\s+/)).filter(p => p[0]);
    if (!set.length) return img.currentSrc || img.src;
    set.sort((a, b) => (parseInt(b[1], 10) || 0) - (parseInt(a[1], 10) || 0));
    return set[0][0];
  };

  const init = () => {
    const gallery = document.querySelector('.pfx-carousel');
    const display = gallery && gallery.querySelector('.gallery-display');
    if (!display || display.dataset.pfxZoom) return;
    display.dataset.pfxZoom = '1';

    const hint = document.createElement('span');
    hint.className = 'pfx-zoom-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.textContent = '🔍 Toca para ampliar';
    display.appendChild(hint);

    const box = document.createElement('div');
    box.className = 'pfx-lightbox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Imagen ampliada');
    box.innerHTML = '<div class="pfx-lightbox__bar"><span data-pfx-lb-count></span><button type="button" class="pfx-lightbox__close" aria-label="Cerrar">×</button></div>' +
      '<div class="pfx-lightbox__scroll"><img alt="" draggable="false"></div>' +
      '<div class="pfx-lightbox__nav"><button type="button" data-pfx-lb-prev>‹ Anterior</button><button type="button" data-pfx-lb-next>Siguiente ›</button></div>';
    document.body.appendChild(box);

    const big = box.querySelector('img');
    const count = box.querySelector('[data-pfx-lb-count]');
    const imgs = () => [...gallery.querySelectorAll('[data-pfx-slide] img.actual')];
    let index = 0, pushed = false;

    const show = i => {
      const list = imgs();
      if (!list.length) return;
      index = (i + list.length) % list.length;
      box.classList.remove('is-zoomed');
      big.src = biggest(list[index]);
      big.alt = list[index].alt || '';
      count.textContent = (index + 1) + ' / ' + list.length + ' · Toca la imagen para acercar';
    };
    const open = i => {
      show(i);
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      try { history.pushState({ pfxLightbox: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    };
    const close = fromPop => {
      if (box.hidden) return;
      box.hidden = true;
      document.documentElement.style.overflow = '';
      if (pushed && !fromPop) { pushed = false; try { history.back(); } catch (e) {} }
      pushed = false;
    };

    display.addEventListener('click', e => {
      const img = e.target instanceof Element && e.target.closest('img.actual');
      if (!img) return;
      const i = imgs().indexOf(img);
      open(i < 0 ? 0 : i);
    });
    box.querySelector('.pfx-lightbox__close').addEventListener('click', () => close(false));
    box.querySelector('[data-pfx-lb-prev]').addEventListener('click', () => show(index - 1));
    box.querySelector('[data-pfx-lb-next]').addEventListener('click', () => show(index + 1));
    big.addEventListener('click', () => box.classList.toggle('is-zoomed'));
    window.addEventListener('popstate', () => close(true));
    document.addEventListener('keydown', e => {
      if (box.hidden) return;
      if (e.key === 'Escape') close(false);
      if (e.key === 'ArrowRight') show(index + 1);
      if (e.key === 'ArrowLeft') show(index - 1);
    });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
